import { React } from "react";

import { Button, Toolbar, SaveButton } from "react-admin";

import { Box } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const DialogToolbar = ({ onCancel }) => {
  return (
    <Toolbar>
      <Box sx={{ flex: 1, display: "flex", justifyContent: "space-between" }}>
        <SaveButton />
        <Button
          sx={{ padding: "6px", fontSize: "0.875rem" }}
          label="Откажи"
          onClick={onCancel}
        >
          <CancelIcon />
        </Button>
      </Box>
    </Toolbar>
  );
};

export default DialogToolbar;
